import { cn } from '#app/utils/misc'

export function Badge({
	children,
	className,
}: {
	children: React.ReactNode
	className?: string
}) {
	return (
		<div
			className={cn(
				'rounded-md bg-muted px-2 py-1 text-sm font-medium',
				className,
			)}
		>
			{children}
		</div>
	)
}

export function BadgeSuccess({ children }: { children: React.ReactNode }) {
	return <Badge className="bg-green-500 text-white">{children}</Badge>
}

export function BadgeWarning({ children }: { children: React.ReactNode }) {
	return <Badge className="bg-yellow-500 text-white">{children}</Badge>
}

export function BadgeDanger({ children }: { children: React.ReactNode }) {
	return <Badge className="bg-red-500 text-white">{children}</Badge>
}
